import React from 'react';
import {Image, Col} from 'react-bootstrap';
import {HobbiesStyle, TextStyle} from '../assets/css/Styles';

/**
 *
 * @param {Object} props - props for each hobby component
 * @return {Component} each hobby component
 */
export default function EachHobby({...props}) {
  return (
    <Col style={HobbiesStyle.eachHobbyContainer}>
      <Col
        style={HobbiesStyle.IconStyleDiv}>
        <Image
          style={HobbiesStyle.IconStyle}
          alt={props.hobbyImageSrc}
          src={props.hobbyImageSrc} />
      </Col>
      <Col style={HobbiesStyle.eachHobbyNameDiv}>
        <span style={TextStyle.normalTxt2}>
          {props.hobbyName}
        </span>
      </Col>
    </Col>
  );
}
